import { Zap, Star, Mic, MessageSquare, BookOpen } from "lucide-react";
import type { ComponentType } from "react";

export type ArticleTag = "breaking" | "scoop" | "interview" | "opinion" | "feature";

interface TagConfig {
  label: string;
  icon: ComponentType<{ className?: string }>;
  className: string;
}

export const articleTagConfig: Record<ArticleTag, TagConfig> = {
  breaking: {
    label: "Breaking",
    icon: Zap,
    className: "bg-red-600 text-white",
  },
  scoop: {
    label: "Scoop",
    icon: Star,
    className: "bg-orange-500 text-white",
  },
  interview: {
    label: "Interview",
    icon: Mic,
    className: "bg-sky-600 text-white",
  },
  opinion: {
    label: "Opinion",
    icon: MessageSquare,
    className: "bg-violet-600 text-white",
  },
  feature: {
    label: "Feature",
    icon: BookOpen,
    className: "bg-emerald-600 text-white",
  },
};
